import * as React from 'react';
const PelleSeccaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}`}</style>
    </defs>
    <path
      d="M94.83 146.4c0-4.3-.11-11.4-1.72-12.03-17.61-6.87-16.03-25.06-30.92-36.09 6.87-12.03 19.75 10.31 24.05 10.31 5.44-15.9-9.88-46.4 0-46.4 4.01 0 7.93 25.32 11.22 25.32s-.7-33.92 7.67-33.92c6.87 0 .36 29.2 4.51 33.35 5.44-.14 3.08-28.19 12.67-28.19 6.01 0-3.95 31.68 0 30.93 3 0 8.3-20.62 13.74-20.62 1.82 0 1.82 1.55 1.72 3.99-.27 6.64-5.59 19.9-7.72 26.69"
      style={{
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '3.89px',
        stroke: primaryColor || '#282828',
      }}
    />
    <path
      d="m118.27 131.5 5.39-6.3 5.4 1.8v4.5l2.7 3.6-1.8 5.4-6.3-2.7-4.5.9.9-3.6z"
      className="prefix__cls-1"
    />
    <path
      d="m108.37 143.19 7.2-.9 3.59-3.59M118.27 131.5l-4.5-3.6h-1.8l-4.5 3.6-3.6 5.4M111.97 127.9l-1.8-2.7 4.5-3.59 8.09.89.9 2.7M124.56 109.01l-3.6 6.3 1.8 7.19M129.06 127l2.7-2.7.9-2.69-.9-2.7-.9-8.1M114.67 121.61l-.9-4.5 7.19-1.8"
      className="prefix__cls-1"
    />
    <path
      d="m101.17 127.9 9-2.7-2.7-5.39.9-3.6 5.4.9M138.95 119.81l-2.69 1.8h-3.6M131.76 135.1l8.99-7.2M129.96 140.5l3.6 2.69M115.57 142.29l.9 4.5M108.37 116.21l-.9-2.7"
      className="prefix__cls-1"
    />
    <circle cx={120.96} cy={127.9} r={19.79} className="prefix__cls-1" />
  </svg>
);
export default PelleSeccaIcon;
